import React, { useEffect, useMemo, useState } from 'react';
import { useI18n } from '../i18n';

interface LoaderProps { text?: string; styleTitle?: string; }

export const Loader: React.FC<LoaderProps> = ({ text, styleTitle }) => {
  const { t } = useI18n();
  const [tipIndex, setTipIndex] = useState(0);
  const [elapsedSeconds, setElapsedSeconds] = useState(0);
  const tips = useMemo(() => [
    t('loaderTip1'), t('loaderTip2'), t('loaderTip3'), t('loaderTip4'),
    t('loaderTip5'), t('loaderTip6'), t('loaderTip7'), t('loaderTip8'),
  ], [t]);

  useEffect(() => {
    const tipInterval = window.setInterval(() => setTipIndex((current) => (current + 1) % tips.length), 8000);
    const timeInterval = window.setInterval(() => setElapsedSeconds((current) => current + 1), 1000);
    return () => { window.clearInterval(tipInterval); window.clearInterval(timeInterval); };
  }, [tips.length]);

  const time = elapsedSeconds < 60
    ? t('loaderSeconds', { count: elapsedSeconds })
    : `${Math.floor(elapsedSeconds / 60)}:${String(elapsedSeconds % 60).padStart(2, '0')}`;

  return <div className="flex flex-col items-center justify-center py-12 space-y-6">
    <div className="loader-3d" />
    <div className="text-center space-y-2">
      <p className="text-white font-semibold text-lg">{text || t('loaderDefault')}</p>
      {styleTitle && <p className="text-accent text-sm font-medium">{t('loaderStyle', { style: styleTitle })}</p>}
      <p className="text-xs text-white/50 animate-pulse">{tips[tipIndex]}</p>
      <div className="mt-4 space-y-1">
        <p className="text-[11px] text-white/60">⏱ {t('loaderElapsed', { time })}</p>
        <p className="text-[10px] text-white/40">{t('loaderHint')}</p>
        {elapsedSeconds > 30 && <p className="text-[10px] text-sheriff-accent/70 animate-pulse">{t('loaderLong')}</p>}
      </div>
    </div>
  </div>;
};
